/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs */

const en_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, logs and daily reports before handoff.`)
};

const ar_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ضوابط وسجلات وتقارير يومية قبل التسليم.`)
};

const bn_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হস্তান্তরের আগে সুরক্ষা, লগ আর দৈনিক রিপোর্ট।`)
};

const de_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schutzmaßnahmen, Protokolle und Tagesberichte vor der Übergabe.`)
};

const es_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protecciones, registros e informes diarios antes de la entrega.`)
};

const fr_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garde-fous, journaux et rapports quotidiens avant la passation.`)
};

const pt_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardrails, registos e relatórios diários antes da entrega.`)
};

const zh_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`交接前配好护栏、日志和日报。`)
};

const tr_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansman öncesi guardrail'ler, kayıtlar ve günlük raporlar.`)
};

const ru_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Гардрейлы, логи и ежедневные отчёты до передачи.`)
};

const pl_svc_ecommerce_amazon_tools_harden_detail6 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardraile, logi i dzienne raporty przed przekazaniem.`)
};

/**
* | output |
* | --- |
* | "Guardrails, logs and daily reports before handoff." |
*
* @param {Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_harden_detail6 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Harden_Detail6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_harden_detail6(inputs)
	return en_svc_ecommerce_amazon_tools_harden_detail6(inputs)
});
export { svc_ecommerce_amazon_tools_harden_detail6 as "svc_ecommerce-amazon-tools_HARDEN_detail" }